import {Component, Inject, Input, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {EventItem, EventStatus, League} from "@model";
import {getLanguageValue, getMultiLanguageValue} from "@utility";
import {TranslocoService} from "@ngneat/transloco";
import {AbstractComponent} from '../abstract.component';
import {DOCUMENT} from "@angular/common";
import {environment} from "@environment";

@Component({
    selector: 'app-share-cta',
    templateUrl: './share-cta.component.html',
    styleUrls: ['./share-cta.component.scss'],
    standalone: false
})
export class ShareCtaComponent extends AbstractComponent implements OnInit {
  @Input() item?: EventItem;
  @Input() leagueItem?: League;
  @Input() isPreviewComponent?: boolean;
  @Input() isShareVisible?: boolean = false;

  label = '';
  description = '';

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private translocoService: TranslocoService,
    @Inject(DOCUMENT) public document: Document
  ) {
    super();
  }

  currentUrl: string = '';

  ngOnInit(): void {
    this.currentUrl = this.document.location.href;

    if (this.item) {
      this.label = getLanguageValue(
        this.item.name, this.item.nameEng, this.item.nameIta,
        this.item.nameSlo, this.item.nameSr,  this.item.nameBs, this.translocoService.getActiveLang()
      ) ?? '';
      this.description = getLanguageValue(
        this.item.description, this.item.descriptionEng, this.item.descriptionIta,
        this.item.descriptionSlo, this.item.descriptionSr,  this.item.descriptionBs, this.translocoService.getActiveLang()
      ) ?? '';
      this.setSEOData(this.label);
      this.isShareVisible = true;
    } else if (this.leagueItem) {
      this.label = getLanguageValue(
        this.leagueItem.name, this.leagueItem.nameEng, this.leagueItem.nameIta,
        this.leagueItem.nameSlo, this.leagueItem.nameSr,  this.leagueItem.nameBs, this.translocoService.getActiveLang()
      ) ?? '';
      this.description = getMultiLanguageValue(
        this.leagueItem?.description, this.translocoService.getActiveLang()
      ) ?? '';
      this.setSEOData(this.label);
      this.isShareVisible = true;
    }
  }

  setSEOData(title: string): void {
    this.titleService.setTitle(title);

    this.metaService.updateTag({property: 'og:title', content: title});

    let url = this.document.location.href.replace("/private", "");

    if (this.item?.status === EventStatus.FINISHED) {
      url = url.replace("/profile/myTracey", "/finishedEvents");
    } else if (this.item && this.item.status !== EventStatus.FINISHED) {
      url = url.replace("/profile/myTracey", "/eventCalendar");
    }
    this.currentUrl = url;
    this.metaService.updateTag({property: 'og:url', content: url});

    this.metaService.updateTag({property: 'og:type', content: 'website'});
    this.metaService.updateTag({property: 'og:site_name', content: environment.site_name});
    this.metaService.updateTag({property: 'og:image', content: this.item?.imageMedium ?? ''});
  }

  copyToClipboard(): void {
    var url = this.currentUrl;
    navigator.clipboard.writeText(url).then(() => {
      const successMessage = this.translocoService.translate('app.share.link.copied');
      alert(successMessage);
    }).catch(err => {
      const errorMessage = this.translocoService.translate('app.share.error.copying.link');
      alert(errorMessage);
      console.error(errorMessage, err);
    });
  }
}
